import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { default as ReactSelect } from 'react-select';
import { components, ControlProps, Props, StylesConfig } from 'react-select';
import Colors from '~/constants/colors';
import styles from './Select.module.scss';

interface SelectItem {
    label: string | ReactNode;
    value: string;
    [x: string]: any;
}

interface SelectProps {
    label?: string;
    error?: string | false;
    disabled?: boolean;
    className?: string;
    required?: boolean;
    placeHolder?: string;
    options?: SelectItem[];
    value: string;
    onChange?: (value: string, options: SelectItem) => void;
    component?: any;
    [x: string]: any;
}

const Select: FC<SelectProps> = ({
    label,
    className,
    error,
    disabled,
    required,
    placeHolder = 'Select',
    options,
    value,
    onChange,
    ...props
}) => {
    const selected = options?.find((op) => op.value === value);

    return (
        <div
            className={classNames(styles.select_container, className, {
                [styles.disabled]: disabled
            })}
        >
            {label ? (
                typeof label === 'string' ? (
                    <label
                        className={classNames(styles.input_label, {
                            [styles.required]: required
                        })}
                    >
                        {label}
                    </label>
                ) : (
                    label
                )
            ) : null}
            <ReactSelect
                value={selected || ''}
                className={classNames(styles.select, styles.select)}
                options={options}
                classNamePrefix="select"
                placeholder={placeHolder}
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: 8,
                        outline: 'none',
                        boxShadow: 'none',
                        borderColor: state.isFocused ? Colors.PRIMARY : Colors.GREY_100
                    })
                }}
                onChange={(op: any) => onChange?.(op?.value || '', op)}
                {...props}
            />
            {error && <span className={styles.error}>{error}</span>}
        </div>
    );
};

export default Select;
